module.exports = __webpack_public_path__ + "static/media/E15.459adc35.jpg";